export const AUTH_TOKEN = 'STOCK_VAULT_ADMIN_AUTH_TOKEN';
